import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { motion } from 'framer-motion';

export const About = () => {
  return (
    <SectionWrapper id="about" className="bg-white">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">Who We Are</h2>
          <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
            <p>
              The <strong className="text-primary-dark">Grassroots Mobilization for APC PBAT Nationwide</strong> is a dedicated political support group committed to the ideals and vision of the All Progressives Congress (APC) and President Bola Ahmed Tinubu (PBAT).
            </p>
            <p>
              Our mission is to deepen democratic engagement and enlightenment at the grassroots level, ensuring that the dividends of democracy reach every ward and local government area across Nigeria. We believe in the power of the people to drive sustainable development and political stability.
            </p>
            <p>
              Through strategic mobilization, community outreach, and political education, we are building a formidable network of loyal party members and supporters who are ready to champion the Renewed Hope agenda.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="/assets/community-hands.jpg"
              alt="Community Unity"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-accent text-white p-8 rounded-xl shadow-xl hidden md:block">
            <p className="text-4xl font-bold mb-2">36+</p>
            <p className="text-sm uppercase tracking-wider">States Covered</p>
          </div>
        </motion.div>
      </div>
    </SectionWrapper>
  );
};
